var _rect, _rect2, _g, _rect3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#DC0032"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1112_1930",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 8,
    width: 17,
    height: 20
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10.2,
    y: 8.58838,
    width: 16,
    height: 18.8235,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1112_1930)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.7418 12.6639L25.521 12.8041C23.9194 13.7458 22.322 14.692 20.716 15.6293C20.5253 15.7162 20.4129 15.9187 20.4389 16.1287C20.4692 16.6893 20.4389 16.6192 20.8978 16.9083C21.0606 17.0371 21.2877 17.0425 21.4562 16.9215C22.928 16.0454 24.4085 15.1694 25.8803 14.2934L26.1487 14.1401C26.152 14.2013 26.152 14.2627 26.1487 14.324V22.3442C26.1545 22.6163 26.002 22.8666 25.7591 22.9837L20.7809 25.9666C20.058 26.4046 19.3307 26.8426 18.6165 27.2807C18.3632 27.4557 18.0299 27.4557 17.7767 27.2807C15.3958 25.844 13.0149 24.4189 10.634 23.0056C10.3541 22.862 10.1843 22.5649 10.2011 22.2478C10.2011 19.6197 10.2011 17.0047 10.2011 14.4029C10.2011 14.324 10.2011 14.2496 10.2011 14.1401L10.4392 14.2715L17.2139 18.2574C17.3682 18.3254 17.4611 18.4867 17.4433 18.656C17.4433 20.6009 17.4433 22.5413 17.4433 24.4861V24.6832C17.4377 24.8131 17.5093 24.9337 17.6251 24.9898L17.9888 25.1957C18.1032 25.2658 18.2466 25.2658 18.3611 25.1957L18.7074 25.003C18.8321 24.9488 18.9088 24.8201 18.8978 24.6832C18.8978 24.6306 18.8978 24.5781 18.8978 24.5255V17.9202C18.8978 17.8588 18.8978 17.8019 18.8978 17.7406C18.902 17.6204 18.8382 17.5082 18.7333 17.4515L18.1836 17.1274L10.8591 12.8041L10.634 12.6683L10.8158 12.5413L17.742 8.71297C18.0073 8.54685 18.3426 8.54685 18.6078 8.71297C20.9238 10.0008 23.2311 11.2666 25.5384 12.5413L25.7418 12.6639Z",
    fill: "white"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.4,
    y: 0.4,
    width: 35.2,
    height: 35.2,
    rx: 17.6,
    stroke: "#AB044A",
    strokeOpacity: 0.36,
    strokeWidth: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.b1595b2586dd22af78e5c925882d77ec.svg";
export { ForwardRef as ReactComponent };